<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img text-left ml-2 mr-2" style="margin-top: 30px; justify-content: center;">
            <!-- Content Row -->
            <div class="card shadow col-md-6 m-auto p-0">
                <div class="card-header pt-1 pb-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white text-center small">
                        <div>
                            CONTAGEM DE ESTOQUE Nº {{ this.id  }}
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                
                <fieldset :disabled="carregando" class="pl-1 pr-1 pb-1">

                  <div class="card-body p-1">
                    <div class="card small mb-2" v-if="this.atividade !== null">
                        <div class="card-body p-2">
                            <span class="font-weight-bold text-danger">{{ atividade.cliente.fantasia }}</span>
                            <br>
                            <span class="font-weight-bold">Endereço: </span>
                            [<span class="text-danger font-weight-bold" v-if="url.includes('localhost') || url.includes('hkcoletor')">
                                {{ atividade.endereco }}
                            </span>
                            <span class="text-danger font-weight-bold no-copy" v-if="!url.includes('localhost') && !url.includes('hkcoletor')">
                               {{ atividade.endereco }}
                            </span>]
                            <br>
                            <span class="font-weight-bold">Produto: </span>
                            [<span class="text-danger font-weight-bold" v-if="url.includes('localhost') || url.includes('hkcoletor')">
                                {{ atividade.codbarras }}
                            </span>
                            <span class="text-danger font-weight-bold no-copy" v-if="!url.includes('localhost') && !url.includes('hkcoletor')">
                                {{ atividade.codbarras }}
                            </span>]
                            <div class="mt-1">
                                <span class="font-weight-bold">Possui Validade: </span> [{{ atividade.lote != null ? "S" : "N" }}]
                                <br>
                                <div v-if="atividade.lote != null">
                                    <span class="font-weight-bold">Lote / Validade: </span> [{{ atividade.lote }}] - [{{ dateFormat(atividade.validade) }}]
                                </div>
                                <span class="font-weight-bold">Qtde. Etoque: </span> {{ atividade.qtde_estoque }}
                                <br>
                                <span class="font-weight-bold">Criada: </span> {{ dateFormat(atividade.data_gravacao) }}
                            </div>
                          </div>
                    </div>

                    <div class="small" v-if="!this.enderecoDestino">
                        <InputDefaultApp
                            idInput="enderecoInput"
                            inputPlaceHolderSufixo="Digite o endereço de contagem"
                            titleScan="Escanear destino"
                            typeInputMode="numeric"
                            :errorMessage="this.enderecoDestinoErrorMessage"
                            @displayScanFunction="buscarEndereco"
                            :enterKey="(e) => buscarEndereco(e.target.value)"
                            :showChangeInputMode="url.includes('localhost') || url.includes('hkcoletor')"
                        >
                        </InputDefaultApp>
                    </div>

                    <div v-if="this.enderecoInformado" class="small">
                        <span class="font-weight-bold">Endereço de Contagem: </span>
                        <span class="text-danger font-weight-bold">{{ this.enderecoDestino.descricao }}</span>
                        <br>
                        <span class="font-weight-bold" v-if="atividade.detalhes.tipo=1">Qtde. Contada: </span>
                        <span class="text-danger font-weight-bold">{{ qtde_contada }} / {{ atividade.qtde_estoque }}</span>
                        <br>
                        <div class="row">
                            <div class="col-12 mt-1">
                                <InputDefaultApp
                                    idInput="produtoInput"
                                    inputPlaceHolderSufixo="Digite o código do produto"
                                    titleScan="Escanear Produto"
                                    typeInputMode="text"
                                    :enterKey="(e) => biparProduto(e.target.value)"
                                    :errorMessage="this.produtoErrorMessage"
                                    :showChangeInputMode="url.includes('localhost') || url.includes('hkcoletor')"
                                >
                                </InputDefaultApp>
                            </div>

                            <div class="col-6 pr-1">
                                <button class="btn btn-sm btn-success btn-block" @click="dialogFinalizarContagem()">
                                    Finalizar<br>Contagem
                                    <em class="fa fa-save ml-2"></em>
                                </button>
                            </div>

                            <div class="col-6 pl-1">
                                <button class="btn btn-sm btn-danger btn-block" @click="zerarContagem()">
                                    Zerar Contagem<br>
                                    <em class="fa fa-undo ml-2"></em>
                                </button>
                            </div>
                            
                        </div>
                    </div>

                    <div class="enderecos" v-if="this.proximosEnderecos.length > 0">
                        <hr>
                        Sujestões de endereços:
                        <br>
                        <div v-for="(item) in this.proximosEnderecos" :key="item.idenderecamento">
                        <span class="text-secondary d-block">{{ item.descricao }}</span>
                        </div>
                    </div>
                  </div>

                </fieldset>
            </div>
        </div>

         <Modal
            id="modalConfirmarContagem"
            title="Confirme:"
            :confirmFunction="() => finalizarContagem()"
            :cancelFunction="() => closeModal('modalConfirmarContagem')"
            confirmText="Sim"
            cancelText="Cancelar"
        >
            <div class="small" v-if="this.atividade">
                <span v-if="this.qtde_contada < this.atividade.qtde_estoque">Deseja fazer uma movimentacao interna deste endereço?</span>
                <span v-if="this.qtde_contada >= this.atividade.qtde_estoque">Deseja finalizar a contagem?</span>
            </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <LogoutModal />
        <FooterBar />
    </div>
</template>
  
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUserId, getUsername, getPerfil  } from '../services/api'
    import InputDefaultApp from "../components/InputDefaultApp.vue";
    import $ from "jquery";
    import audioService from '@/services/audioService.js';
    import Modal from "../components/Modal.vue";

  export default {
    name: 'ContagemEstoque',
    mixins: [
      ViewMixin,
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      InputDefaultApp,
      Modal,
    },
  
    data: () => {
      return {
        url: window.location.href,
        id: null,
        atividade : null,
        enderecoAtual: null,
        enderecos: [],
        proximosEnderecos: [],
        enderecoInformado: false,
        enderecoDestino: null,
        enderecoDestinoErrorMessage: null,
        retornoMessage: null,
        qtde_contada: 0,
        produtoErrorMessage: null,
      };
    },
  
    async mounted() {

      try {
        let id = this.$route.params.id;
        this.id = id;

        await this.validarToken();
        await this.getAtividade(id);

      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
        getUsername,
        getPerfil,
        getUserId,

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        playSound() {
            audioService.ops();
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        onModalClosed() {
            //
        },

        async getAtividade(id) {

            this.carregando = true;

            try {

                let result = await api.get(`/atividades/${id}`);
                this.atividade = result.data.atividade;
                this.qtde_contada = result.data.atividade.qtde_contagem;

                setTimeout(() => {
                    $("#enderecoInput").focus();
                }, 500);
            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },

        async buscarEndereco(endereco) {
            try {
                let response = await api.post("/inbound/segundaconferencia/endereco", {
                    descricao: endereco
                });

                if (JSON.stringify(response.data).includes("descricao"))
                {   
                    if (endereco != this.atividade.endereco) {
                        this.enderecoDestinoErrorMessage = "Endereço precisa ser o mesmo exibido acima!";
                        this.enderecoInformado = false;
                        this.playSound();
                    } else if (response.data.descricao.trim() == endereco) {
                        $("#enderecoInput").val(response.data.descricao);
                        this.enderecoDestinoErrorMessage = "";
                        this.enderecoInformado = true;
                        this.enderecoDestino = response.data;

                        setTimeout(() => {
                            $("#produtoInput").val("");
                            $("#produtoInput").focus();
                        }, 1000);
                    }
                } else {
                    this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                    this.enderecoInformado = false;
                    $("#enderecoInput").focus();
                    $("#enderecoInput").select();
                    this.playSound();
                }
            } catch (e) {
                this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                this.enderecoInformado = false;
                $("#enderecoInput").focus();
                $("#enderecoInput").select();
                this.playSound();
                console.log(e);
            }
        },

        async biparProduto(barras) {
            if (barras == this.atividade.codbarras) {
                let qtde = (this.qtde_contada + 1);

                try {
                    let result = await api.post(`/atividades/produto/bipar`, {
                        id: this.id,
                        qtde: qtde
                    });

                    if (JSON.stringify(result.data).includes("updated")) {
                        if (result.data.updated) {
                            this.qtde_contada = qtde;
                            this.produtoErrorMessage = null;
                            $("#produtoInput").select();
                            $("#produtoInput").focus();
                        }
                    }
                } catch(e) {
                    console.log(e);
                    $("#produtoInput").select();
                    $("#produtoInput").focus();
                    this.produtoErrorMessage = e.message;
                    this.playSound();
                }
            } else {
                $("#produtoInput").select();
                $("#produtoInput").focus();
                this.produtoErrorMessage = "Código de barras inválido!";
                this.playSound();
            }
        },

        async zerarContagem() {

            try {
                let result = await api.post(`/atividades/produto/bipar`, {
                    id: this.id,
                    qtde: 0
                });

                if (JSON.stringify(result.data).includes("updated")) {
                    if (result.data.updated) {
                        this.qtde_contada = 0;

                        setTimeout(() => {
                            $("#produtoInput").val("");
                            $("#produtoInput").focus();
                        }, 250);
                    }
                }
            } catch(e) {
                console.log(e);
                $("#produtoInput").select();
                $("#produtoInput").focus();
                this.produtoErrorMessage = e.message;
                this.playSound();
            }
        },

        dialogFinalizarContagem() {
            $('#modalConfirmarContagem').modal('show');
        },

        finalizarContagem() {
            this.closeModal('modalConfirmarContagem');

            if (this.qtde_contada < this.atividade.qtde_estoque) {
                this.$router.push('/movimentacao/interna?atividade=' + this.id)
            } else {
                this.finalizarAtividade();
            }
        },

        async finalizarAtividade() {
            this.carregando = true;

            try {
                let result = await api.post(`/atividades/finalizar`, {
                  id: this.atividade.idatividade
                });

                if (result.status == 200) {
                    this.$router.push("/atividades");
                }

            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },
    }
  }
</script>
  
<style scoped lang="scss">
    .scroll-view {
      height: 220px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .enderecos {
      height: 110px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .no-copy {
        -webkit-user-select: none; /* Chrome/Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* IE/Edge antigo */
        user-select: none;         /* padrão */
    }
</style>